export enum ChatKeys {
    MerchantGroupTeam = 'merchant-group-${0}'
}